import Vue from 'vue'
import API from '@/api/'
import store from '@/store'
import router from '@/router'
export default (method, options) => {
  let loader = Vue.$loading.show({
    backgroundColor: '#3498db',
    color: '#ffffff',
    opacity: 1,
    transition: 'none',
    height: 128,
    width: 128,
    loader: 'dots',
    zIndex: 300000
  })

  return API()
    .post('/api.php',
      {
        method: method,
        options: options
      }
    ).then(response => {
      response.data = JSON.parse(response.data.trim())
      loader.hide()
      if (response.data.error !== 'true') {
        return response
      }
      throw response.data
    }).catch(error => {
      // todo make smarter error handling
      if (error.code === '000005' || error.code === '000019') {
        store.dispatch('authLogout', true).then(() => {
          router.push({name: 'Login'})
          throw error
        })
      } else {
        throw error
      }
    })
}



// WEBPACK FOOTER //
// ./src/api/post/index.js